import React from 'react';
import './CustomProgressBar.scss';

const CustomProgressBar = ({ currentStep, numberOfSteps, className = '' }) => {
  const progressPercentage = numberOfSteps > 1 ? ((currentStep - 1) / (numberOfSteps - 1)) * 100 : 0;

  return (
    <div className={`custom-progress-bar ${className}`}>
      <div className="progress-container">
        <div className="progress-track">
          <div
            className="progress-fill"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
        <div className="progress-steps">
          {Array.from({ length: numberOfSteps }, (_, index) => {
            const stepNumber = index + 1;
            const isCompleted = stepNumber < currentStep;
            const isCurrent = stepNumber === currentStep;

            return (
              <div
                key={stepNumber}
                className={`progress-step ${isCompleted ? 'step-completed' : ''} ${isCurrent ? 'step-current' : ''}`}
                style={{ left: numberOfSteps > 1 ? `${(index / (numberOfSteps - 1)) * 100}%` : '50%' }}
              >
                <div className="step-circle">
                  {isCompleted ? (
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path
                        d="M10 3L4.5 8.5L2 6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <span className="step-number">{stepNumber}</span>
                  )}
                </div>
                <div className="step-label">
                  Stap {stepNumber}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CustomProgressBar;